const FORMATS = [
  {
    tag: "循环动图",
    icon: "ri-repeat-2-line",
    title: "黑料色动图",
    desc: "高能瞬间被抽成无限循环，反复看也上头。按情绪切好，伸手就捞到合适的那个。",
    meta: "12.4w 个场景位 · 每日上新",
    img: "https://readdy.ai/api/search-image?query=a_single_stylized_loop_frame_from_a_reacting_gif_with_a_playful_shocked_cartoon_face_made_of_bold_red_and_amber_shapes_on_a_clean_warm_cream_background_flat_modern_vector_style_high_energy_high_contrast_no_text_minimal_entertainment_aesthetic&width=640&height=420&seq=hero-gif-01&orientation=landscape",
  },
  {
    tag: "切片短视频",
    icon: "ri-video-line",
    title: "黑料色短视频",
    desc: "完整回放太长？这里只留最炸的那一段。入戏到高能之间的节奏已被重新卡准。",
    meta: "8.6w 段 · 平均 45 秒一段",
    img: "https://readdy.ai/api/search-image?query=abstract_energetic_video_clip_frame_with_radiating_warm_red_orange_light_glow_and_play_button_shadow_on_a_soft_cream_studio_background_stylized_modern_motion_graphics_no_text_minimal_high_contrast_entertainment_cover_style&width=640&height=420&seq=hero-video-01&orientation=landscape",
  },
  {
    tag: "录屏回放",
    icon: "ri-record-circle-line",
    title: "黑料色录屏",
    desc: "直播与现场的回放录屏，原汁原味不剪情绪。实时弹幕没跟上的，回放里再补一遍。",
    meta: "3.2w 段 · 支持进度卡位",
    img: "https://readdy.ai/api/search-image?query=stylized_screen_recording_window_ui_with_a_round_red_recording_dot_top_corner_and_abstract_amber_timeline_bars_on_a_warm_cream_interface_minimal_flat_vector_illustration_no_readable_text_high_contrast_modern_tool_aesthetic&width=640&height=420&seq=hero-record-01&orientation=landscape",
  },
  {
    tag: "梗图表情",
    icon: "ri-emotion-laugh-line",
    title: "黑料色表情包",
    desc: "把高能名场面压成一张表情，聊到点上直接甩。表情包按情绪词库分好，找起来顺手。",
    meta: "19.1w 张 · 支持一键存",
    img: "https://readdy.ai/api/search-image?query=collection_of_bold_round_meme_sticker_badges_in_warm_red_amber_and_cream_with_simple_flat_vector_faces_no_readable_text_scattered_on_a_minimal_cream_background_playful_high_contrast_modern_sticker_shop_aesthetic&width=640&height=420&seq=hero-sticker-01&orientation=landscape",
  },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 pt-14 pb-16 md:px-6 md:pt-20 md:pb-24">
        {/* 顶部一句话定位 */}
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-xs font-medium text-secondary-900">
            <i className="ri-focus-2-line text-primary-600" />
            黑料色 · 按场景切片整理的内容聚合站
          </span>
          <h1 className="mt-6 font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
            黑料色动图、短视频、录屏、
            <br className="hidden md:block" />
            片段剪辑与表情包，<span className="text-primary-600">一站收齐</span>
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-7 text-foreground-600 md:text-base">
            想找黑料色动态图、视频剪辑或录屏资源，不用再东翻西找。这里把它们按场景切好，
            打开就能看，也方便收藏转发。
          </p>
          <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#scene"
              className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-play-fill text-base" />
              按场景翻今天的切片
            </a>
            <a
              href="#rank"
              className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-100 px-6 py-3 text-sm font-medium text-foreground-800 transition hover:bg-background-200 sm:w-auto"
            >
              先看今日热榜
              <i className="ri-arrow-right-up-line text-base text-primary-600" />
            </a>
          </div>
        </div>

        {/* 多卡并列首屏 */}
        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 md:mt-20">
          {FORMATS.map((f) => (
            <a
              key={f.tag}
              href="#stream"
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition hover:border-primary-200 hover:bg-background-100"
            >
              <div className="relative aspect-[640/420] w-full overflow-hidden">
                <img
                  src={f.img}
                  alt={`${f.title}封面`}
                  title={`${f.title} · 黑料色动图素材`}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-950/70 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur">
                  {f.tag}
                </span>
                <span className="absolute inset-0 flex items-center justify-center opacity-0 transition group-hover:opacity-100">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50">
                    <i className="ri-play-fill text-xl" />
                  </span>
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2">
                  <i className={`${f.icon} text-base text-primary-600`} />
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{f.title}</h3>
                </div>
                <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{f.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="text-xs text-foreground-500">{f.meta}</span>
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-background-200 text-foreground-600 transition group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className="ri-arrow-right-line text-sm" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}